import { Box, Spinner } from "@chakra-ui/react";
import React from "react";
import { useIsFetching } from "react-query";

export default function GlobalLoadingIndicator() {
  const isFetching = useIsFetching();

  if (isFetching) {
    return (
      <Box
        p={2}
        position="absolute"
        right="0px"
        top="75px"
        bg="white"
        borderLeftRadius="8px"
        boxShadow="base"
        zIndex="9999"
      >
        <Spinner />
      </Box>
    );
  }

  return null;
}
